import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Planets_Table from '../views/Planets_Table.vue';
import Planets_Atlas from '../views/Planets_Atlas.vue';
import Characters_Table from '../views/Characters_Table.vue';
import Graph_Viewer from '../views/Graph_Viewer.vue';
import Sparql from '../views/Sparql.vue';
import Datasets from '../views/Datasets.vue';
import Holo_Word from '../views/Holo_Word.vue';
import Holo_Page from '../views/Holo_Page.vue';
import Stardle from '../views/Stardle.vue';
import Contribute from '../views/Contribute.vue';
import Roadmap from '../views/Roadmap.vue';
import About from '../views/About.vue';
import TermsOfService from '@/components/TermsOfService.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/planets/table',
    name: 'Planets Table',
    component: Planets_Table
  },
  {
    path: '/planets/atlas',
    name: 'Galactic Atlas',
    component: Planets_Atlas
  },
  {
    path: '/characters',
    name: 'Characters Table',
    component: Characters_Table
  },
  {
    path: '/graphviewer',
    name: 'Graph Viewer',
    component: Graph_Viewer
  },
  {
    path: '/data/sparql',
    name: 'SPARQL',
    component: Sparql
  },
  {
    path: '/data/datasets',
    name: 'Datasets',
    component: Datasets
  },
  {
    path: '/games/holoword',
    name: 'Holoword',
    component: Holo_Word
  },
  {
    path: '/games/stardle',
    name: 'Stardle',
    component: Stardle
  },
  {
    path: '/games/holopage',
    name: 'Holopage',
    component: Holo_Page
  },
  {
    path: '/contribute',
    name: 'Contribute',
    component: Contribute
  },
  {
    path: '/roadmap',
    name: 'Roadmap',
    component: Roadmap
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/tos',
    name: 'Terms of Service',
    component: TermsOfService
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;